<script setup>

import RecordVideo from "@/components/main/recordVideo/recordVideo.vue";
import {computed, onMounted, ref, watch} from "vue";
import {useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();

const title = computed(() => languageStore.get('videoMinutes'));
const emits = defineEmits(['set_title'])

const SearchDateSetter= (searchDate)=>{
  searchDate.value = searchDate;
}

onMounted(()=>{
  emits('set_title', title.value);
})
watch(title, (v) => emits('set_title', v))
</script>

<template>
  <div class="recordVideoArea">
    <record-video :meetingType="'mt000'" ></record-video>
  </div>
</template>

<style scoped>

</style>